import { useTranslation } from '@nucleus-commerce/i18n/react';
import { Button } from '@nucleus-commerce/ui/components/button';

export interface PickerFooterProps {
  onClear: () => void;
  /** "Today" for a date, "Now" for a date and time. */
  nowLabel: string;
  onNow: () => void;
  nowDisabled: boolean;
}

/** Chrome's footer: Clear on the left, Today (or Now) on the right. */
export function PickerFooter({ onClear, nowLabel, onNow, nowDisabled }: PickerFooterProps) {
  const { t } = useTranslation('common');
  return (
    <div className="flex items-center justify-between gap-2 border-t p-2">
      <Button type="button" variant="ghost" size="sm" onClick={onClear}>
        {t('dateTime.clear')}
      </Button>
      <Button type="button" variant="ghost" size="sm" disabled={nowDisabled} onClick={onNow}>
        {nowLabel}
      </Button>
    </div>
  );
}
